var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "yxtbiz-ac-work-audit" }, [
    _c("div", { staticClass: "standard-size-16 color-gray-10" }, [
      _c(
        "div",
        { staticClass: "mb32 font-bolder" },
        [
          _vm._v(
            "\n      " +
              _vm._s(_vm.$t("pc_biz_ac_enroller_info" /** 申请人信息 */)) +
              "\n      "
          ),
          _c(
            "yxtf-row",
            {
              staticClass: "mv24 font-normal font-size-14",
              attrs: { type: "flex" },
            },
            [
              _c(
                "yxtf-col",
                { staticClass: "mh2 flex", attrs: { span: 12 } },
                [
                  _c("span", { staticClass: "color-gray-7 nowrap" }, [
                    _vm._v(
                      _vm._s(_vm.$t("pc_biz_ac_enroller_name" /** 姓名 */)) +
                        "："
                    ),
                  ]),
                  _c(
                    "yxtf-tooltip",
                    { attrs: { "open-filter": true, placement: "top" } },
                    [
                      _c(
                        "div",
                        { attrs: { slot: "content" }, slot: "content" },
                        [
                          _c("yxtbiz-user-name", {
                            attrs: { name: _vm.detail.userName },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "yxtbiz-teacher-enroll-audit_ellipsis" },
                        [
                          _c("yxtbiz-user-name", {
                            attrs: { name: _vm.detail.userName },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "yxtf-col",
                { staticClass: "mh2 flex", attrs: { span: 12 } },
                [
                  _c("span", { staticClass: "color-gray-7 nowrap" }, [
                    _vm._v(
                      _vm._s(_vm.$t("pc_biz_ac_enroller_dept" /**  部门 */)) +
                        "："
                    ),
                  ]),
                  _c(
                    "yxtf-tooltip",
                    { attrs: { "open-filter": true, placement: "top" } },
                    [
                      _c(
                        "div",
                        { attrs: { slot: "content" }, slot: "content" },
                        [
                          _c("yxtbiz-dept-name", {
                            attrs: { name: _vm.detail.deptName },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "yxtbiz-teacher-enroll-audit_ellipsis" },
                        [
                          _c("yxtbiz-dept-name", {
                            attrs: { name: _vm.detail.deptName },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "yxtf-row",
            {
              staticClass: "font-normal font-size-14",
              attrs: { type: "flex" },
            },
            [
              _c(
                "yxtf-col",
                { staticClass: "mh2 flex", attrs: { span: 12 } },
                [
                  _c("span", { staticClass: "color-gray-7 nowrap" }, [
                    _vm._v(
                      _vm._s(_vm.$t("pc_biz_ac_enroller_possion" /**岗位 */)) +
                        "："
                    ),
                  ]),
                  _c(
                    "yxtf-tooltip",
                    { attrs: { "open-filter": true, placement: "top" } },
                    [
                      _c(
                        "div",
                        { attrs: { slot: "content" }, slot: "content" },
                        [
                          _c("yxtbiz-position-name", {
                            attrs: { name: _vm.detail.position },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "yxtbiz-teacher-enroll-audit_ellipsis" },
                        [
                          _c("yxtbiz-position-name", {
                            attrs: { name: _vm.detail.position },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "mb32 font-bolder" },
        [
          _vm._v(
            "\n      " +
              _vm._s(_vm.$t("pc_biz_ac_enroll_acinfo" /** 活动信息 */)) +
              "\n      "
          ),
          _c(
            "yxtf-row",
            {
              staticClass: "mv24 font-normal font-size-14",
              attrs: { type: "flex" },
            },
            [
              _c(
                "yxtf-col",
                { staticClass: "mh2 flex", attrs: { span: 12 } },
                [
                  _c("span", { staticClass: "color-gray-7 nowrap" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t("pc_biz_ac_enroll_acname" /** 活动名称 */)
                      ) + "："
                    ),
                  ]),
                  _c(
                    "yxtf-tooltip",
                    {
                      attrs: {
                        "open-filter": true,
                        content: _vm.detail.projectName,
                        placement: "top",
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "yxtbiz-teacher-enroll-audit_ellipsis" },
                        [_vm._v(_vm._s(_vm.detail.actName))]
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "mb32 font-bolder" },
        [
          _vm._v(
            "\n      " +
              _vm._s(_vm.$t("pc_biz_ac_work_name" /** 作品信息 */)) +
              "\n      "
          ),
          _c(
            "yxtf-row",
            {
              staticClass: "mv24 font-normal font-size-14",
              attrs: { type: "flex" },
            },
            [
              _c("yxtf-col", { staticClass: "mh2 flex", attrs: { span: 24 } }, [
                _c("span", { staticClass: "color-gray-7 nowrap" }, [
                  _vm._v(
                    _vm._s(_vm.$t("pc_biz_ac_work_info" /** 作品简介 */)) + "："
                  ),
                ]),
                _c("span", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.lineWrapResolve(_vm.detail.introduction)
                    ),
                  },
                }),
              ]),
            ],
            1
          ),
          _c(
            "yxtf-row",
            {
              staticClass: "mv24 font-normal font-size-14",
              attrs: { type: "flex" },
            },
            [
              _c(
                "yxtf-col",
                { staticClass: "mh2 flex", attrs: { span: 24 } },
                [
                  _c(
                    "yxt-button",
                    { attrs: { type: "text" }, on: { click: _vm.viewDetails } },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.$t("pc_biz_ac_work_view_info" /** 查看作品详情 */)
                        )
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }